import types from '../action/types'

// user : undefined means not designed
//        null means not login
export default function auth(state = { user: undefined }, action) {
  switch (action.type) {
  case types.GET_CURRENT_USER: {
    const user = action.payload
    const isAdmin = user && user.level === 'admin'
    return { ...state, user, isAdmin };
  }
  case types.GET_MEMBERS: {
    const members = action.payload
    const isLeaderOrAdmin = members && Object.keys(members).length > 0
    return { ...state, members, isLeaderOrAdmin };
  }
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducer/authReducer.js